import { useTranslation } from "@outschool/localization";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

export default function useCDPEnrollOrSeeScheduleCTA({
  activity,
}: {
  activity: {
    isClub: boolean;
    isSelfPaced: boolean;
    isSoldOut: boolean;
    upcomingAvailableSectionCount: number;
    canEnroll: boolean;
  };
}) {
  const { t } = useTranslation(
    "client\\components\\detailPage\\hooks\\useCDPEnrollOrSeeScheduleCTA",
  );
  const isMobile = useIsMobile();

  return React.useMemo(() => {
    if (activity.isClub) {
      return t("Join Group");
    }
    if (activity.isSoldOut || !activity.canEnroll) {
      return t("Join Waitlist");
    }

    if (activity.isSelfPaced && !isMobile) {
      return t("Enroll");
    }
    return t("See Schedule");
  }, [
    t,
    activity.isClub,
    activity.isSelfPaced,
    activity.isSoldOut,
    activity.canEnroll,
    isMobile,
  ]);
}
